import { ErrorEnum } from '@/components/Error/types';

export const SET_ERROR = 'Errors / SET_ERROR';

export interface ErrorsState {
  type: ErrorEnum | null;
}
